export const Constants = {
    api: {
        authLogin: 'https://www.tahagasht.com/api/users/login',
        authRegister: 'https://www.tahagasht.com/api/users/register',
        authForgot: 'https://www.tahagasht.com/api/users/forgot',
        authResetPasswordForgot: 'https://www.tahagasht.com/api/users/resetpasswordforgot',
        authVerifyTemp: 'https://www.tahagasht.com/api/users/verifytemp',
        authLoginByVerifyCode: 'https://www.tahagasht.com/api/users/loginbyverifycode',
        profilePassword: 'https://www.tahagasht.com/api/users/changepassword',
        profileUpdate: 'https://www.tahagasht.com/api/users/update',
        profileTravelerRemove: 'https://www.tahagasht.com/api/user/traveler/remove/',
        profileTravelerAdd: 'https://www.tahagasht.com/api/user/traveler/add',
        profileTravelerEdit: 'https://www.tahagasht.com/api/user/traveler/edit/',
        profileTravelers: 'https://www.tahagasht.com/api/user/travelers',
        profileInfo: 'https://www.tahagasht.com/api/users/info',
        profileOrders: 'https://www.tahagasht.com/api/user/orders',
        profileOrder: 'https://www.tahagasht.com/api/user/order/tc/',
        profileOrderUpdate: 'https://www.tahagasht.com/api/user/order/update/status',
        profileOrderAmendment: 'https://www.tahagasht.com/api/cancelrequestsite',
        profileOrderMaster: 'https://www.tahagasht.com/api/contractread',
        profileTicketCategories: 'https://www.tahagasht.com/api/support/categories/list',
        profileTicketSubCategories: 'https://www.tahagasht.com/api/support/subcategories/list/',
        profileTicketSearch: 'https://www.tahagasht.com/api/support/tickets/search',
        profileTicketDetail: 'https://www.tahagasht.com/api/support/tickets/detail/',
        profileTicketAdd: 'https://www.tahagasht.com/api/support/tickets/add',
        profileTicketReply: 'https://www.tahagasht.com/api/support/tickets/reply/',
        ticket: 'https://www.tahagasht.com/api/ticket/',
        flightsSearch: 'https://www.tahagasht.com/api/airlowfaresearch',
        flightsRules: 'https://www.tahagasht.com/api/airrules',
        flightsAirports: 'https://www.tahagasht.com/api/airports/autofill/',
        flightsBook: 'https://www.tahagasht.com/api/airbook',
        flightsPredefines: 'https://www.tahagasht.com/web_api/app_predefined_airports.php',
        flightsCalendarList: 'https://www.tahagasht.com/api/flightcalendar/list',
        formCampaignCoupon: 'https://www.tahagasht.com/web_api/form_campaign_coupon.php',
        formPay: 'https://www.tahagasht.com/web_api/form_pay.php',
        hfSearch: 'https://www.tahagasht.com/api/airhotelsearch',
        hfRooms: 'https://www.tahagasht.com/api/rest/api/HotelRooms',
        hfHotelRules: 'https://www.tahagasht.com/api/rest/api/HotelRules',
        hfHotelInfo: 'https://www.tahagasht.com/api/rest/api/HotelDesc',
        hfBook: 'https://www.tahagasht.com/api/airhotelbook',
        hotelsCities: 'https://www.tahagasht.com/api/cities/autofill/',
        hotelsBook: 'https://www.tahagasht.com/api/hotelreserve',
        hotelsRules: 'https://www.tahagasht.com/api/hotelrules',
        hotelsInfo: 'https://www.tahagasht.com/api/hoteldesc',
        hotelsPredefines: 'https://www.tahagasht.com/web_api/app_predefined_cities.php',
        hotelsSearch: 'https://www.tahagasht.com/api/hotelsearch',
        hotelsRooms: 'https://www.tahagasht.com/api/hotelrooms',
        flightHotelSearch: 'https://www.tahagasht.com/api/airhotelsearch',
        flightHotelBook: 'https://www.tahagasht.com/api/airhotelbook',
        translates: 'https://www.tahagasht.com/web_api/translates.php',
        countries: 'https://www.tahagasht.com/web_api/countries.php',
        couponCheck: 'https://www.tahagasht.com/api/verifydiscountcode',
        blog: 'https://www.tahagasht.com/web_api/app_blog.php',
        blogDetails: 'https://www.tahagasht.com/web_api/app_blog_details.php',
        socials: 'https://www.tahagasht.com/web_api/app_socials.php',
        links: 'https://www.tahagasht.com/web_api/app_links.php',
        page: 'https://www.tahagasht.com/web_api/app_page.php',
        slides: 'https://www.tahagasht.com/web_api/app_slides.php',
        newsletter: 'https://www.tahagasht.com/web_api/app_newsletter.php',
        contact: 'https://www.tahagasht.com/web_api/app_contact.php',
        config: 'https://www.tahagasht.com/web_api/app_config.php',
        blocksIcons: 'https://www.tahagasht.com/web_api/app_blocks_icons.php',
        resultsCustomText: 'https://www.tahagasht.com/web_api/app_results_custom_text.php',
    },
    domain: 'https://www.tahagasht.com',
    uploads: 'https://www.tahagasht.com/uploads/',
    airlines: 'https://booking.connectota.com/assets/images/airlines/',
    paymentCallback: {
        flight: 'https://www.tahagasht.com/index.php?type=flights-reservation-callback-app',
        hotel: 'https://www.tahagasht.com/index.php?type=hotels-reservation-callback-app',
        flightHotel: 'https://www.tahagasht.com/index.php?type=tours-reservation-callback-app'
    },
    flightMaxPassengers: 9,
    hotelMaxPassengers: 9
}